import { render, staticRenderFns } from "./specialtyPlan.vue?vue&type=template&id=e857c794&scoped=true"
import script from "./specialtyPlan.vue?vue&type=script&lang=js"
export * from "./specialtyPlan.vue?vue&type=script&lang=js"
import style0 from "./specialtyPlan.vue?vue&type=style&index=0&id=e857c794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e857c794",
  null
  
)

export default component.exports